import { render, staticRenderFns } from "./m_recruit027.vue?vue&type=template&id=68e21088&scoped=true&"
import script from "./m_recruit027.vue?vue&type=script&lang=js&"
export * from "./m_recruit027.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e21088",
  null
  
)

export default component.exports